import { put, takeEvery } from 'redux-saga/effects'
import { setNestedPropertyValue } from '../utils';
import { setCookieWithExpirationInSeconds } from '@mdigital/common/dist/utils/cookies';
import { APP_INIT, CP_INIT, CUSTOM_PARAMS_FETCH } from '../constants/actionTypes';
import { getCustomParams } from '../services/onsiteService';
import { setCustomParamsState, setCustomParamsError } from '../actions/customParamsActions';
import { CUSTOM_PARAM_SOURCES } from '../constants/enums';
import { groupByOrigin, normalize, mergeWithValues } from '../utils/customParamsUtils';
import { deserializeCPFromUrl } from '../services/urlGeneratorService'


export function assignNonURLCustomParamsValues(contextWindow, customParamsArr = []) {
  customParamsArr
    .forEach(cp => {
      switch (cp.source.toLowerCase()) {
        case CUSTOM_PARAM_SOURCES.VAR:
          //We dont want to simulate and change a window defined key such as location in preview mode.
          if (!isKeyAlreadyOnGlobalObj(contextWindow, cp.sourceName)) {
            setNestedPropertyValue(contextWindow, cp.sourceName, cp.value)
          }
          break;
        case CUSTOM_PARAM_SOURCES.COOKIE:
          if (cp.value != null) {
            setCookieWithExpirationInSeconds(cp.sourceName, cp.value, 60); // expires after 1 minute
          }
          else {
            setCookieWithExpirationInSeconds(cp.sourceName, null, 0);
          }

          break;
        default:
          break;
      }
    });
}

function isKeyAlreadyOnGlobalObj(contextWindow, cpSourceName) {
  const cpProperties = cpSourceName.split('.');
    let object = contextWindow;
    return !cpProperties.some((prop) => { // returns TRUE only when all 'cpSourceName' props exist in contextWindow
        if (!object.hasOwnProperty(prop)) {
            return true;
        }
        object = object[prop];
        return false;
    });
}

function getCookiesCustomParams(customParams) {
  return customParams.filter(cp => cp.source.toLowerCase() === CUSTOM_PARAM_SOURCES.COOKIE);
}

function clearCookies(customParams) {
  const cookiesParams = getCookiesCustomParams(customParams);
  if (cookiesParams) {
    cookiesParams.forEach(cp => {
      setCookieWithExpirationInSeconds(cp.sourceName, null, 0);
    })
  }
}
function getCustomParamsFromUrl() {
  return normalize(deserializeCPFromUrl());
}
function* customParamsSetHandler({ payload }) {
  try {
    const savedCPValues = getCustomParamsFromUrl();
    assignNonURLCustomParamsValues(payload.contextWindow, savedCPValues);
  } catch (e) {
    console.warn(e);
    yield put(setCustomParamsError(e));
  }
}

function* customParamsSagaHandler(action) {
  try {
    const customParamOnsiteDefs = groupByOrigin(getCustomParams());
    const savedCPValues = getCustomParamsFromUrl();

    const shouldNotSimulateCustomParams = savedCPValues.length === 0;
    if (shouldNotSimulateCustomParams) {
      clearCookies(customParamOnsiteDefs);
    }

    const mergedCPs = mergeWithValues(customParamOnsiteDefs, savedCPValues);

    yield put(setCustomParamsState(mergedCPs));
  } catch (e) {
    console.warn(e);
    yield put(setCustomParamsError(e));
  }
}

function* customParamsSaga() {
  yield takeEvery(CP_INIT, customParamsSetHandler);
  yield takeEvery(CUSTOM_PARAMS_FETCH, customParamsSagaHandler);
}

export default customParamsSaga;
